module.exports = __webpack_public_path__ + "img/bg-audio-4.d7e6a8cd.png";